import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = '¡QUIERO EL CÓDIGO DE INSULINA 55+!',
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={() => {
    if (onClick) {
      onClick();
    } else {
      document.getElementById('precio')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }} className={`bg-brand-orange hover:bg-brand-light text-white font-bold py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(232,130,12,0.4)] transition-colors duration-300 w-full md:w-auto text-lg md:text-xl uppercase tracking-wide ${className}`} data-id="element-13">
      {text}
    </motion.button>;
}